<script>
    import Header from '../global/header.svelte'
    import Loader from '../widgets/loader.svelte'
    import GameEnd from "./gameEnd.svelte";
    import { onMount } from 'svelte';
    import { fly } from 'svelte/transition';
    import { pannable } from '../../pannable';
    import { watchResize } from "svelte-watch-resize";
    import { memberStore } from '../../store.js';

    

    export let stageImageURL = "";
    export let spriteImageURL = "";
    export let finishImageURL = "";
    export let gameDay = "";
    export let targetW = "";
    export let targetH = "";
    export let prizeImageURL;
    export let compSpread;
    export let termsURL;


     /**
     * The user object from the store
     * @type {Object}
     */
     let user;
  
    memberStore.subscribe(member => {
        user = member
    });

    
     let preExit = false;

   
    /** @type {HTMLElement} */
    let gameStage
	
    /** @type {HTMLElement} */
    let starElem;


    /**
     * The x translation of the star while it's being dragged.
     * @type {Number}
     */
     let starTranslateX = 0;

    /**
     * The y translation of the star while it's being dragged.
     * @type {Number}
     */
    let starTranslateY = 0;

    /** @type {HTMLElement} */
    let targetElem;

    /** 
     * Determines how much the element and target have to overlap on BOTH the X 
     * and Y axis before the element is deemed dropable. `1` indicates any 
     * overlap is allowed. `.5` means at least 50% of the element must overlap 
     * the drop target.
     * @type {Number}
     */
    const dropThreshold = .5;

    /** @type {Boolean} */
    let isOverTarget = false;

    /** 
     * Indicates that the user is dragging the star
     * @type {Boolean}
     */
    let isDragging = false;

    /**
     * Indicates that star was dropped on the target
     */
    let isComplete = false;

     /**
     * Indicates that star was dropped on the target
     */
    let hasStarted = false;

    /**
     * Indicates that page is loading
     */
    let loading = true;


    /**
     * Event handler for starting to pan an element
     * @param {Event} event
     */
    const handlePanStart = event => {
        isDragging = true;
    }

    /**
     * Event handler for pan an element. Checks for element/target overlap and
     * sets `isOverTarget` accordingly.
     * @param {Event} event
     */
    const handlePanMove = event => {
        starTranslateX += event.detail.dx;
        starTranslateY += event.detail.dy;
        // TODO: throttle these checks:
        const starBound = starElem.getBoundingClientRect();
        const targetBound = targetElem.getBoundingClientRect();
        const xThreshold = starBound.width * (1 - dropThreshold);
        const yThreshold = starBound.height * (1 - dropThreshold);
        isOverTarget = 
            starBound.right >= targetBound.left + xThreshold && 
            starBound.left <= targetBound.right - xThreshold && 
            starBound.bottom >= targetBound.top + yThreshold && 
            starBound.top <= targetBound.bottom - yThreshold;
    }

    /**
     * Event handler for ending panning of an element. Checks for element/target 
     * overlap and snaps the element into position.
     * @param {Event} event
     */
    const handlePanEnd = event => {
        isDragging = false;
        if (isOverTarget) {
            // calcuate how far we need to move the star so it sits in the 
            // correct place on the drop target.
            const starBound = starElem.getBoundingClientRect();
            const targetBound = targetElem.getBoundingClientRect();
            starTranslateX += -(starBound.x - targetBound.x);
            starTranslateY += -(starBound.y - targetBound.y);
            handleTaskComplete();
         } else {
            // reset the star
            starTranslateX = 0;
            starTranslateY = 0;
        }
    }

    /**
     * Handle task completion. This runs once the user has successfully dropped
     * the star onto the target.
     */
    const handleTaskComplete = () => {

        
        // -- Set boolean Flag to display finish Modal
        isComplete = true

        document.body.classList.remove("notouch");

        // -- Sent details to the Server
        
        let formData = new FormData();
        formData.append('number', user.number);
        formData.append('zip', localStorage.getItem('zip') );

        // -- Enter the comp via API
        fetch("https://api.southernco-op.co.uk/member/enterPromotionComp", {
            headers: {
                'Accept': 'application/json',
            },
            method: "POST",
            body: formData
        })
        .then( response => response.json() )
        .then( data => {
            if( data.error ) {
                if( data.error == "PROMO_EXPIRED") {
                    // -- Handle Expired Promo
                }
                if( data.error == "SQL_ERROR") {
                    // -- Handle SQL Error
                }
                if( data.error == "DUPLIACTE_ENTRY") {
                   // -- Handle Duplicate Entry
                }
            } else {
                
            }
        } )                
        .catch( err => {
            serverError = true;
        }); 
        // -- Disable Events on Drag
        

       //alert("Logic for game end has fired")

    }

    const startGame = ()  => {
        hasStarted = true;
    }

    /**
     * Handle area resizing
     */
    function handleAreaResize(node) {
       //console.log( "resize" );
    }

    onMount(async () => {
		loading = false;
        document.body.classList.add("notouch");
	});

    memberStore.subscribe(member => {
        user = member
    });


    const endGame = () => {

        preExit = true;

    }


    const getUserFirstName = ( name ) => {

        if( !name ) return;

        var splits = name.split(" ");
        if( splits[0] ) {
            return splits[0]
        } else {
            return "";
        }

       }

</script>


<svelte:head>
    <title>Christmas Game Day {gameDay}</title>
</svelte:head>


<style>

    :global(body.notouch) {
        overflow: hidden;
    }

    .gameboard {
        text-align: center;
        position: relative;
        pointer-events: none;
        user-select: none;
        min-height: 70vh;
        position: relative;
    }
    .gameboard > img {
        height: 60vh;
        width: auto;
        pointer-events: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%)
    }
    .gameboard__draggable,
    .gameboard__target {
        position: absolute;
        width: 15vh;
        height: 15vh;
    }
    
    .gameboard__draggable {
        left: 50%;
        bottom: 0;
        pointer-events: all;
        transition: .3s transform;
        margin-left: -6vh;
    }
    .gameboard__target {
        top: 30%;
        left: 50%;
         transform:  translateY(-50%) translateX(-50%);
         
       /* background: yellow; */
    }
    .gameboard__draggable {
        transform: translate(var(--x), var(--y));
        z-index: 11;
    }

    .gameboard__draggable img {
        /*animation: shake 4.72s ease infinite;*/ 
        animation: pulsate-fwd 0.5s ease-in-out infinite both;
        backface-visibility: hidden;
        perspective: 1000px;
    }

    

    .frame {
        display: flex;
        flex-direction: column;
        height: 100vh;
    }
    .frame > section {
        flex-grow: 1;
        padding-top: 5vh;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }
    .isOverTarget {
        /*border: 4px solid blue*/
    }
    .isDragging {
        transition: none;
        /*border: 4px solid green;*/
    }
    .isDragging img {
        animation: none;
    }
    .gameboard__modal {
        position: fixed;
        top:50%;
        left:50%;
        background:#fff;
        border-radius: 20px;
        width: calc(100% - 3em);
        min-height: 10em;
        max-width: 40em;
        transform: translate(-50%,-50%);
        box-shadow: 0 2px 8px 1px #0003;
        padding:20px;
        color:#000;
        z-index: 11111;
        color: var(--dark-color);
        text-align: center;
    }

    .gameboard__modal--complete {
        background-color: var(--brand-color)
      
    }

    

     .gameboard__modal a,
    .gameboard__modal button {
        background: var(--brand-color);
        color: var(--dark-color);
        text-align: center;
        border: none;
        border-radius: 25px;
        font-size: 22px;
        padding: 10px 25px;
        font-weight: 600;
        margin: 0;
        display: inline-block;
    }

     .gameboard__modal--complete a {
        background-color: var(--dark-color);
        color: var(--brand-color);
    }

    

     .gameboard__modal  h3 {
        font-weight:  400;
        font-size: 3.2rem;
        line-height: 1.1;
        margin: 0 0 20px 0;
        color: var(--dark-color);
    }
    
    .gameboard__modal p {
        font-size: 1.4rem;
        margin: 0 0 20px 0;   
    }

    .gameboard__modal--complete h3 {
        text-transform: uppercase;
        font-size: 1.6rem;
        font-weight: 400;
        margin-bottom: 5px;
    }

    .gameboard__modal--complete p {
        text-transform: uppercase;
         font-size: 2.6rem;
         font-weight: 600;
    }

    .gameboard__modal--complete svg:nth-of-type(1),
    .gameboard__modal--complete svg:nth-of-type(3) {
        color: #fff;
        width: 25px;
        height: auto;
        animation: slide-in-blurred-bottom 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) .2s both;
    }

    .gameboard__modal--complete svg:nth-of-type(1) {
        transform: rotate(-5deg);
        
        
    }

    .gameboard__modal--complete svg:nth-of-type(2) {
        color: var(--dark-color);
        margin: 0 15px;
        width: 35px;
        height: auto;
        animation: slide-in-blurred-bottom 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) .5s both;
    }

    .gameboard__modal--complete svg:nth-of-type(3) {
        transform: rotate(5deg)
    }

    .modal__stars {
        margin-bottom: 15px;
    }

    .isComplete .gameboard { 
        pointer-events: none;
    }

    .isComplete .gameboard__draggable img {
        animation: none;
    }

    .isComplete {
        position: relative;
    }

    .isComplete:after { 
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 111;    
    }

    .stage__instructions {
        color: var(--brand-color);
        text-align: center;
        font-size: 12px;
        line-height: 14px;
        padding: 0 5vw;
    }
    .stage__instructions a {
        color: var(--brand-color);
        text-decoration: underline;
    }

    .stageSFinish {
        opacity: 0;
        position: relative;
        z-index: -1;
        transition: all .3s ease-in-out
    }

    .stageStart {
        opacity: 1;
        position: relative;
        z-index: 1;
        transition: all .3s ease-in-out
    }

    .isComplete .stageSFinish {
        opacity: 1;
        z-index: 1
    }

    .isComplete .stageStart {
        opacity: 0;
        z-index: -11
    }

    @keyframes shake {
        0% { transform:translate(0,0) }
        1.78571% { transform:translate(10px,0);  }
        3.57143% { transform:translate(0,0) }
        5.35714% { transform:translate(10px,0) }
        7.14286% { transform:translate(0,0) }
        8.92857% { transform:translate(10px,0) }
        10.71429% { transform:translate(0,0) }
        100% { transform:translate(0,0) }
    }

    @keyframes pulsate-fwd {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
        }


    @keyframes slide-in-blurred-bottom {
        0% {
            transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
            transform-origin: 50% 100%;
            filter: blur(40px);
            opacity: 0;
        }
        100% {
            transform: translateY(0) scaleY(1) scaleX(1);
            transform-origin: 50% 50%;
            filter: blur(0);
            opacity: 1;
        }
    }

.prize_image {
    margin: 1em auto;
    max-width: 150px;
    display: block
}

</style>

<div id="gameFrame" class="frame">
    <Header title="Day {gameDay}" url="/" /> 
    <section class="stage" class:isComplete>
       
        <div>
            {#if !loading}
                {#if !hasStarted}
                    <div class="gameboard__modal" transition:fly={{y:20, duration:300}}>
                        <h3>Welcome {getUserFirstName(user.name)}!</h3>
                        <p>To be in with a chance of winning today's prize you must drag the missing item into place...</p>
                        <img class="prize_image" src="{prizeImageURL}" alt="Your Prize" />
                        <button on:click|once={startGame}>Start Game</button>
                    </div>
                {/if}

                {#if isComplete}
                    <div class="gameboard__modal gameboard__modal--complete" transition:fly={{y:20, duration:300, delay:2000}}>
                        <div class="modal__stars">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" class="svg-inline--fa fa-star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"></path></svg>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" class="svg-inline--fa fa-star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"></path></svg>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" class="svg-inline--fa fa-star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"></path></svg>
                        </div>
                        <h3>Thank you for your entry!</h3>
                        
                        <p>Good Luck!</p>
                        <a href="/">Finish</a>
                    </div>
                {/if}

                <div class="gameboard" bind:this={gameStage}>
                    <img src="{stageImageURL}" class="stageStart" alt="" />
                    <img src="{finishImageURL}" class="stageSFinish" alt="" />
                    <div bind:this={targetElem} class="gameboard__target" class:isOverTarget style="width:{targetW};height:{targetH}"></div>
                    <div bind:this={starElem} class="gameboard__draggable" class:isDragging style="--x:{starTranslateX}px;--y:{starTranslateY}px;width:{targetW};height:{targetH}" use:pannable use:watchResize={handleAreaResize} on:panstart={handlePanStart} on:panend={handlePanEnd} on:panmove={handlePanMove}>
                        <img src="{spriteImageURL}" alt="" />
                    </div>
                </div>
                <div class="stage__instructions">
                    <p>Southern Co-op Competition, prize to be won each day this week ({compSpread}) more details can be found over on our Facebook page. Winners will be contacted next week.  <a target="_blank"  href="{termsURL}">{termsURL}</a></p>
                </div>
            {:else}
                <Loader msg="Loading Game" />
            {/if}
        </div>
    </section>
    {#if isComplete}
        <GameEnd />
    {/if}
</div>
